module.exports = __webpack_public_path__ + "img/library.757ba681.svg";